import { useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import descDGI from "../images/dgi/banner_dgi.png";
import descDLE from "../images/dle/banner_dle.png";
import descMCGIE from "../images/mcgie/banner_mcgie.png";
import descDBI from "../images/dbi/banner_dbi.png";

import posgrado0 from "../images/resources/posgrado0.png";
import number1 from "../images/posgrado/1.png";
import number2 from "../images/posgrado/2.png";
import number3 from "../images/posgrado/3.png";
import number4 from "../images/posgrado/4.png";
import number5 from "../images/posgrado/5.png";

import Modal from "@mui/material/Modal";
import PaginaPosgrado from "../components/PaginaPosgrado";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Slider from "react-slick";
import Box from "@mui/material/Box";

import { carouselSettings } from "../utils/Carrousel.config.js";

import AnimatedSection from "../components/AnimatedSection.js";
import ImageCard from "../components/ImageCard";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function Posgrado() {
  const content = {
    dgi: {
      title:
        "Decimo octava versión - Diplomado en Gestión Integrada, Calidad, Medioambiente, Seguridad y Salud Ocupacional",
      image: descDGI,
      description:
        "El objetivo del Diplomado es desarrollar competencias técnicas y de gestión que permitan implementar, mantener y mejorar sistemas de gestión integrados basados en las normas ISO 9001 (Calidad), ISO 14001 (Medioambiente) e ISO 45001 (Seguridad y Salud Ocupacional), con el fin de optimizar el desempeño organizacional, garantizar la satisfacción del cliente, prevenir riesgos laborales y minimizar los impactos ambientales.",
      registrationOpening: "Mayo 2026",
    },
    dle: {
      title:
        "Undécima versión - Diplomado en Logística Empresarial y Gestión de la Cadena de Suministros",
      image: descDLE,
      description:
        "El Objetivo del Diplomado es dotar a los profesionales con los elementos básicos de la logística moderna y la gestión de las cadenas de suministro, de forma tal que les posibilite actuar eficientemente en las tareas relacionadas con el análisis y gestión de los sistemas logísticos como centro de la gestión de las cadenas de suministro.",
      registrationOpening: "Abril 2026",
    },
    mcgie: {
      title:
        "Duodécima versión - Maestría en Ciencias de Gestión Industrial y Empresarial",
      image: descMCGIE,
      description:
        "El objetivo de la Maestría es formar profesionales con conocimientos sólidos y habilidades avanzadas en la gestión industrial y empresarial, capaces de diseñar, implementar y liderar procesos estratégicos, operativos y tecnológicos dentro de organizaciones competitivas y sostenibles.",
      registrationOpening: "Agosto 2026",
    },
    dbi: {
      title:
        "Primera versión - Diplomado en Biotecnología Industrial y Aplicaciones Estratégicas",
      image: descDBI,
      description:
        "El Diplomado en Biotecnología Industrial y Aplicaciones Estratégicas tiene como objetivo formar profesionales altamente capacitados en el área de biotecnología industrial, con énfasis en la aplicación estratégica de procesos biotecnológicos para el desarrollo sostenible y la innovación tecnológica.",
      registrationOpening: "Abril 2026",
    },
  };
  const [isModalActive, setIsModalActive] = useState(false);
  const [modalState, setModalState] = useState("");
  return (
    <>
      <Modal open={isModalActive} onClose={() => setIsModalActive(false)}>
        <PaginaPosgrado type={modalState} />
      </Modal>
      <Stack spacing={2}>
        <Typography variant="h2" align="center" sx={{ my: 2 }}>
          <strong>
            Posgrado del Instituto de Investigaciones Industriales
          </strong>
        </Typography>
        <Divider sx={{ mb: 3 }} />
        <AnimatedSection>
          <Typography
            variant="body1"
            align="justify"
            sx={{
              py: 8,
              px: 4,
              backgroundImage: `url(${posgrado0})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              borderRadius: 2,
              color: "white",
              textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          >
            El Posgrado del Instituto de Investigaciones Industriales de la
            Facultad de Ingeniería de la UMSA ofrece programas de formación
            avanzada orientados a la excelencia académica y profesional.
            Nuestros Programas de Posgrado están diseñados para fortalecer las
            competencias de los profesionales en áreas clave de la gestión
            industrial, logística y empresarial, contribuyendo al desarrollo y
            la innovación en el sector productivo nacional.
          </Typography>
        </AnimatedSection>

        <Divider sx={{ mb: 3 }} />
        <Typography variant="h4" align="center">
          <strong>Nuestros Programas de Posgrado</strong>
        </Typography>
        <AnimatedSection>
          <Slider {...carouselSettings}>
            <ImageCard
              admisions={content.dgi.registrationOpening}
              img={content.dgi.image}
              title={content.dgi.title}
              description={content.dgi.description}
              click={() => {
                setModalState("dgi");
                setIsModalActive(true);
              }}
              width={"75%"}
            />
            <ImageCard
              admisions={content.dle.registrationOpening}
              img={content.dle.image}
              title={content.dle.title}
              description={content.dle.description}
              click={() => {
                setModalState("dle");
                setIsModalActive(true);
              }}
              width={"75%"}
            />
            <ImageCard
              admisions={content.mcgie.registrationOpening}
              img={content.mcgie.image}
              title={content.mcgie.title}
              description={content.mcgie.description}
              click={() => {
                setModalState("mcgie");
                setIsModalActive(true);
              }}
              width={"75%"}
            />
            <ImageCard
              admisions={content.dbi.registrationOpening}
              img={content.dbi.image}
              title={content.dbi.title}
              description={content.dbi.description}
              click={() => {
                setModalState("dbi");
                setIsModalActive(true);
              }}
              width={"75%"}
            />
          </Slider>
        </AnimatedSection>
        <Divider sx={{ mb: 3 }} />
        <Box
          sx={{
            borderRadius: 2,
          }}
        >
          <Grid
            maxWidth={"100%"}
            item
            container
            spacing={2}
            sx={{
              my: 5,
              color: "white",
              textShadow: "1px 1px rgba(0, 0, 0, 0.5)",
            }}
          >
            <Grid item size={{ xs: 12, md: 4 }} sx={{ height: "fit-content" }}>
              <AnimatedSection>
                <ImageCard img={number1} width={"90%"} />
              </AnimatedSection>
            </Grid>
            <Grid item size={{ xs: 12, md: 4 }} sx={{ height: "fit-content" }}>
              <AnimatedSection>
                <ImageCard img={number2} width={"90%"} />
              </AnimatedSection>
            </Grid>
            <Grid item size={{ xs: 12, md: 4 }} sx={{ height: "fit-content" }}>
              <AnimatedSection>
                <ImageCard img={number3} width={"90%"} />
              </AnimatedSection>
            </Grid>
            <Grid item size={{ xs: 12, md: 6 }} sx={{ height: "fit-content" }}>
              <AnimatedSection>
                <ImageCard img={number4} width={"90%"} />
              </AnimatedSection>
            </Grid>
            <Grid item size={{ xs: 12, md: 6 }} sx={{ height: "fit-content" }}>
              <AnimatedSection>
                <ImageCard img={number5} width={"90%"} />
              </AnimatedSection>
            </Grid>
          </Grid>
        </Box>
        <Divider sx={{ mb: 3 }} />
        <Typography variant="h3" align="center">
          <strong>Preguntas frecuentes</strong>
        </Typography>
        <Box maxWidth="fit-content" mx="auto" my={4} px={5}>
          <Accordion sx={{ mb: 2, borderRadius: 2, boxShadow: 2 }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="faq1-content"
              id="faq1-header"
              sx={{
                fontSize: 18,
                bgcolor: "green",
                color: "white",
                borderRadius: 2,
              }}
            >
              ¿Cuándo y cómo realizo el pago del programa?
            </AccordionSummary>
            <AccordionDetails
              sx={{ bgcolor: "background.paper", fontSize: 16 }}
            >
              Los pagos se realizan una vez iniciado el programa, generalmente
              en cuotas mensuales. El proceso de pago se detalla durante la
              inscripción y se puede realizar a través de plataformas de pago de
              la Universidad Mayor de San Andrés.
            </AccordionDetails>
          </Accordion>
          <Accordion sx={{ mb: 2, borderRadius: 2, boxShadow: 2 }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="faq2-content"
              id="faq2-header"
              sx={{
                fontSize: 18,
                bgcolor: "green",
                color: "white",
                borderRadius: 2,
              }}
            >
              No cuento con el Título de pregrado, pero estoy en proceso de
              titulación ¿Puedo inscribirme?
            </AccordionSummary>
            <AccordionDetails
              sx={{ bgcolor: "background.paper", fontSize: 16 }}
            >
              Sí, es posible inscribirse en el programa de posgrado si estás en
              proceso de titulación. Sin embargo, es importante que completes tu
              proceso de titulación antes de finalizar el programa de posgrado,
              ya que el título de pregrado es un requisito para la obtención del
              título de posgrado.
            </AccordionDetails>
          </Accordion>
          <Accordion sx={{ mb: 2, borderRadius: 2, boxShadow: 2 }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="faq3-content"
              id="faq3-header"
              sx={{
                fontSize: 18,
                bgcolor: "green",
                color: "white",
                borderRadius: 2,
              }}
            >
              Cuento con título a nivel Técnico Superior, ¿Puedo inscribirme en
              un programa de posgrado?
            </AccordionSummary>
            <AccordionDetails
              sx={{ bgcolor: "background.paper", fontSize: 16 }}
            >
              Sí, puedes inscribirte a nuestros programas de posgrado si cuentas
              con un título a nivel Técnico Superior. Sin embargo, es importante
              que el título sea en provisión nacional o sea reconocido por el
              Ministerio de Educación de Bolivia.
            </AccordionDetails>
          </Accordion>
          <Accordion sx={{ mb: 2, borderRadius: 2, boxShadow: 2 }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="faq3-content"
              id="faq3-header"
              sx={{
                fontSize: 18,
                bgcolor: "green",
                color: "white",
                borderRadius: 2,
              }}
            >
              ¿Debo realizar algún pago para inscribirme?
            </AccordionSummary>
            <AccordionDetails
              sx={{ bgcolor: "background.paper", fontSize: 16 }}
            >
              Para inscribirte en nuestros programas de posgrado solo necesitas
              enviarnos los requisitos solicitados, el pago se realiza una vez
              se de inicio con el programa de posgrado.
            </AccordionDetails>
          </Accordion>
        </Box>
        <Divider sx={{ mb: 3 }} />
      </Stack>
    </>
  );
}

export default Posgrado;
